import { INDEX_NAME, } from "../../../interfaces";
import { getAttributeId } from "../getAttributeKey";
import { getDictionariesBody } from "../../../api/fetchesApiProducts";
import { getValuedAttributeKeysDictionary } from "./";
import { msearchEs } from "../../../api/fetchesApiSearch";
export const getDictionariesToSearch = (items, columns) => {
    const confs = [];
    items.forEach(({ data }) => {
        const attributeKeys = getValuedAttributeKeysDictionary(data, columns);
        attributeKeys.forEach((attributeKey) => {
            const { attrId } = getAttributeId(attributeKey);
            const column = columns.find((c) => c.id === attrId);
            const { dictionaryType, dictionaryId } = column.editField;
            const c = confs.find((x) => x.attributeId === attrId &&
                x.dictionaryType === dictionaryType &&
                x.dictionaryId === dictionaryId);
            if (!c) {
                confs.push({
                    attributeId: attrId,
                    dictionaryType,
                    dictionaryId,
                    value: {},
                });
            }
        });
        attributeKeys.forEach((attributeKey) => {
            const { attrId, ctlgId } = getAttributeId(attributeKey);
            const column = columns.find((c) => c.id === attrId);
            const { dictionaryType, dictionaryId, multiSelectable } = column.editField;
            const c = confs.find((x) => x.attributeId === attrId &&
                x.dictionaryType === dictionaryType &&
                x.dictionaryId === dictionaryId);
            if (!c.value[ctlgId]) {
                c.value[ctlgId] = [];
            }
            const codesSet = new Set(c.value[ctlgId]);
            const codesValue = multiSelectable
                ? data[attributeKey]
                : [data[attributeKey]];
            codesValue.forEach((v) => {
                if (!codesSet.has(v)) {
                    c.value[ctlgId].push(v);
                }
            });
        });
    });
    return confs;
};
export const getDataDictionaries = async ({ aggregateType, items, columns, error, }) => {
    try {
        if (error)
            throw "NO_LOAD";
        const dictToSearch = getDictionariesToSearch(items, columns);
        if (!dictToSearch.length)
            throw "NO_DICTS";
        const mres = await msearchEs({
            aggregateType,
            data: dictToSearch.map((x) => ({
                index: INDEX_NAME.DICTIONARIES,
                body: getDictionariesBody(x),
            })),
        });
        const res = [];
        mres.forEach((r, i) => {
            const { attributeId } = dictToSearch[i];
            const dictionaries = r.items.map((item) => {
                return { id: item.id, ...item.data };
            });
            const dataDictionary = {
                attributeId,
                dictionaries,
            };
            res.push(dataDictionary);
        });
        return res;
    }
    catch (err) {
        return [];
    }
};
